import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {UserService} from "../user/user.service";

@Injectable()
export class AuthenticationGuardService implements CanActivate {

    constructor(private router: Router, private auth: AuthenticationService,
                private user: UserService) {
    }

    canActivate(): Promise<boolean> {
        const vm = this;
        return this.auth.isAuthenticated().then((authenticated) => {
            if (this.user.currentUser && vm.user.isAllowedInEmployeeApp(vm.user.currentUser)) {
                let canActivate = authenticated ? true : false;
                if (!canActivate) {
                    this.router.navigate(['auth/login']);
                }
                return canActivate;
            } else {
                this.router.navigate(['auth/login']);
                return false;
            }
        });
    }

}
